<template>
  <div class="event_guide">
    <div class="sub_title">
      <h3>{{ subTitle }}</h3>
      <!-- 운임대상별 요금 다른 경우 표기 -->
      <!-- <caption class="table_caption">
				<div class="icon_wrap">
					<inline-svg :src="require('@/assets/img/icon/adult.svg')" />
				</div>
				<span class="icon_name">성인</span>
				<div class="icon_wrap child">
					<inline-svg :src="require('@/assets/img/icon/child.svg')" />
				</div>
				<span class="icon_name">어린이</span>
				<div class="icon_wrap old">
					<inline-svg :src="require('@/assets/img/icon/old.svg')" />
				</div>
				<span class="icon_name">경로</span>
			</caption> -->
    </div>
    <div class="guide_table">
      <table>
        <thead>
          <tr>
            <th v-for="(header, idx) in headers" :key="idx">
              {{ header.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(content, idx) in contents" :key="idx">
            <template v-for="(header, idx) in headers" :key="idx">
              <td v-if="header.value === 'lineRouteName'">
                <a class="map_I route" @click="openMapInfo(content)"></a>
                <span class="map_I" @click="openMapInfo(content)">
                  {{ content[header.value] || "-" }}
                </span>
              </td>
              <td v-else-if="header.value === 'fares'">
                <template v-if="content[header.value]?.length > 1">
                  <div
                    class="fare"
                    v-for="(fare, idx) in content[header.value]"
                    :key="idx"
                  >
                    <div
                      class="icon_wrap"
                      :class="{
                        child: fare.fareTargetCode === 'FTG-CHILD',
                        old: fare.fareTargetCode === 'FTG-OLD',
                      }"
                    >
                      <span>{{ fare.fareTargetName?.substr(0, 1) }}</span>
                    </div>
                    <span class="icon_name">{{
                      fare.fareAmount.toLocaleString()
                    }}</span>
                  </div>
                </template>
                <template v-else>
                  {{
                    content[header.value]
                      ? content[header.value][0].fareAmount.toLocaleString()
                      : "-"
                  }}
                </template>
              </td>
              <td v-else v-html="content[header.value] || '-'"></td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
// import InlineSvg from 'vue-inline-svg';

export default {
  name: "LineInfoTable",
  // components: {
  // 	InlineSvg,
  // },
  props: {
    subTitle: {
      type: String,
    },
    headers: {
      type: Array,
    },
    contents: {
      type: Array,
    },
  },
  setup(_props, { emit }) {
    const store = useStore();
    const serviceInfo = computed(() => store.state.common.serviceInfo);
    const openMapInfo = async (content) => {
      const result = await store.dispatch("line/FETCH_STATION_LIST", {
        lineTurnUid: content.lineTurnUid,
        params: { driveDate: serviceInfo.value?.driveDates[0].date },
      });
      const nowStationIndex =
        result.findIndex((station) => station.uid === content.stationUid) ?? 0;
      emit("openMapInfo", result, nowStationIndex + 1);
    };
    return { openMapInfo };
  },
};
</script>
